import { Component, Input } from '@angular/core';
import { AppStateInterface } from '../../../store/state/app.state';
import { Store } from '@ngrx/store';
import {
  hasSubscriptionSelector,
  userBalanceSelector,
} from '../../../store/selectors/billing.selectors';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import {
  expertIsTypingSelector,
  expertNameSelector,
} from '../../../store/selectors/expert.selectors';
import { isFreeUserRegisteredSelector } from '../../../store/selectors/event-variables.selectors';
import { toggleMobileMenu } from '../../../store/actions/system.actions';
import { ClickhouseService } from '../../../shared/services/clickhouse.service';
import { MultiChatService } from '../../../shared/services/multi-chat.service';
import { eventIdSelector, uuidSelector } from '../../../store/selectors/profile.selectors';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  @Input() title: string = '';

  expertName: string = '';

  isExpertTyping: boolean = false;

  userBalance: number = 0;

  hasSubscription: boolean = false;

  userIsFree: boolean = false;

  currentPath: string = '';

  eventId: string = '';

  token: string = '';

  constructor(
    private store: Store<AppStateInterface>,
    private modalService: NgbModal,
    private router: Router,
    private clickHouse: ClickhouseService,
    private multiChatService: MultiChatService,
  ) {
    this.store.select(userBalanceSelector).subscribe((userBalance) => {
      this.userBalance = userBalance;
    });
    this.store.select(hasSubscriptionSelector).subscribe((hasSubscription) => {
      this.hasSubscription = hasSubscription;
    });
    this.store.select(expertNameSelector).subscribe((expertName) => {
      this.expertName = expertName;
    });
    this.store.select(expertIsTypingSelector).subscribe((isExpertTyping) => {
      this.isExpertTyping = isExpertTyping;
    });
    this.store.select(isFreeUserRegisteredSelector).subscribe((isFreeUserRegistered) => {
      this.userIsFree = isFreeUserRegistered;
    });
    this.store.select(uuidSelector).subscribe((uuid) => {
      this.token = uuid;
    });
    this.store.select(eventIdSelector).subscribe((eventId) => {
      this.eventId = eventId;
    });
    this.getPageTitle().subscribe((pageTitle) => {
      this.title = pageTitle;
      this.currentPath = this.router.url.split('?')[0];
    });
  }

  billingBtnClick(event: any) {
    event.preventDefault();
    if (this.hasSubscription) {
      import('../../modals/billing-modal/billing-modal-component.module').then(
        ({ BillingModalComponentModule }) => {
          const BillingModalComponent = BillingModalComponentModule.getComponent();
          this.modalService.open(BillingModalComponent, {
            backdrop: 'static',
            keyboard: false,
          });
        },
      );
    } else {
      import('../../modals/plan-modal/plan-modal-component.module').then(
        ({ PlanModalComponentModule }) => {
          const PlanModalComponent = PlanModalComponentModule.getComponent();
          this.modalService.open(PlanModalComponent, {
            backdrop: 'static',
            keyboard: false,
          });
        },
      );
    }
  }

  // You can set page title on relative ...-routing.module.ts
  private getPageTitle() {
    return this.router.events.pipe(
      map(() => {
        let route: ActivatedRoute = this.router.routerState.root;
        let routeTitle = '';
        while (route.firstChild) {
          route = route.firstChild;
        }
        if (route.snapshot.data.title) {
          routeTitle = route.snapshot.data.title;
        }
        this.currentPath = this.router.url;
        return routeTitle;
      }),
    );
  }

  toggleMobileMenu() {
    this.clickHouse.storeEvent('mobile_menu_open_click').subscribe(() => {});
    this.store.dispatch(toggleMobileMenu());
  }

  async openLogoutModal() {
    this.clickHouse.storeEvent('logout_click').subscribe(() => {});
    import('../../modals/question-modal/question-modal-component.module').then(
      ({ QuestionModalComponentModule }) => {
        const QuestionModalComponent = QuestionModalComponentModule.getComponent();
        this.modalService.open(QuestionModalComponent, {
          backdrop: 'static',
          keyboard: false,
        });
      },
    );
  }

  outFromTicket() {
    this.multiChatService.userOutFromTicket$.next(true);
  }

  installApp() {
    this.clickHouse.storeEvent('mobile_banner_install_app_click').subscribe(() => {});
    window.location.href = `https://mathmaster.onelink.me/Vtkz/hrqip26o?eventid=${this.eventId}&token=${this.token}`;
  }
}
